<template>
  <Layout>
    <!-- <PageHeader :title="title" :items="items" /> -->
    <div class="row">
      <div class="col-9 mb-4">
        <div class="mb-4">
          <h3 style="text-transform: capitalize">
            {{ $t("dashboards.welcome") }}, {{ loginname }} !
          </h3>
        </div>
        <div class="row">
          <div class="col-sm-3 text-center">
            <h1 class="text-warning mb-1">
              <b>{{ total_analys }}</b>
            </h1>
            <h5>{{ $t("dashboards.analyst") }}</h5>
          </div>
          <div class="col-sm-3 text-center">
            <h1 class="text-success mb-1">
              <b>{{ total_validator }}</b>
            </h1>
            <h5>{{ $t("dashboards.verifier") }}</h5>
          </div>
          <div class="col-sm-3 text-center">
            <h1 class="text-danger mb-1">
              <b>{{ total_uploads }}</b>
            </h1>
            <h5>{{ $t("dashboards.uploaded-malware") }} (s)</h5>
          </div>
          <div class="col-sm-3 text-center">
            <h1 class="text-info mb-1">
              <b>{{ total_report }}</b>
            </h1>
            <h5>{{ $t("dashboards.report-total") }}</h5>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12 mb-4">
            <MalwareRecapitulation
              :statInterval="sortInterval"
              :statSandbox="select_sandbox"
              :startDate="start_range"
              :endDate="end_range"
            />
          </div>
          <div class="col-6">
            <div
              class="border rounded"
              :class="theme == 'light' ? 'bg-white' : 'border-info'"
            >
              <div class="">
                <div class="card-body h-100">
                  <h4 class="card-title mb-4">
                    {{ $t("dashboards.top-virus") }}
                  </h4>
                  <div>
                    <div v-if="!loading_grafik && series_families[0]">
                      <apexchart
                        class="apex-charts"
                        dir="ltr"
                        height="370"
                        :series="series_families.slice(0, 9)"
                        :options="{
                          stroke: {
                            colors: ['#e5e5e5'],
                          },
                          legend: {
                            show: true,
                            showForSingleSeries: false,
                            showForNullSeries: true,
                            showForZeroSeries: true,
                            position: 'bottom',
                            horizontalAlign: 'center',
                            floating: false,
                            fontSize: '14px',
                            fontFamily: 'Helvetica, Arial',
                            fontWeight: 400,
                            formatter: undefined,
                            inverseOrder: false,
                            width: undefined,
                            height: undefined,
                            tooltipHoverFormatter: undefined,
                            customLegendItems: [],
                            offsetX: 0,
                            offsetY: 0,
                            labels: {
                              colors: '#fff',
                              useSeriesColors: false,
                            },
                            markers: {
                              width: 12,
                              height: 12,
                              strokeWidth: 0,
                              strokeColor: '#fff',
                              fillColors: undefined,
                              radius: 12,
                              customHTML: undefined,
                              onClick: undefined,
                              offsetX: 0,
                              offsetY: 0,
                            },
                            itemMargin: {
                              horizontal: 5,
                              vertical: 4,
                            },
                            onItemClick: {
                              toggleDataSeries: true,
                            },
                            onItemHover: {
                              highlightDataSeries: true,
                            },
                          },
                          chart: {
                            type: 'pie',
                          },
                          labels: labels_families.slice(0, 9),
                          colors: [
                            '#78350f',
                            '#92400e',
                            '#b45309',
                            '#d97706',
                            '#f59e0b',
                            '#fbbf24',
                            '#fcd34d',
                            '#fde68a',
                            '#fef3c7',
                            '#fffbeb',
                          ],

                          plotOptions: {
                            pie: {
                              donut: {
                                size: '60%',
                              },
                            },
                          },
                        }"
                      ></apexchart>
                    </div>
                    <div v-if="loading_grafik">
                      <div class="text-center py-4 my-5">
                        <i class="bx bx-loader-circle bx-spin bx-md"></i> <br />
                        <span class="font-size-16"> Loading ... </span>
                      </div>
                    </div>
                    <div v-if="!loading_grafik && !series_families[0]">
                      <div class="m-5 p-5">
                        <div class="text-center py-4 my-5">
                          <span class="py-5 my-5">
                            {{ $t("dashboards.data-not-found") }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div
              class="border rounded"
              :class="theme == 'light' ? 'bg-white' : 'border-info'"
            >
              <div class="">
                <div class="card-body h-100">
                  <h4 class="card-title mb-4">
                    {{ $t("dashboards.analyzed-malware") }}
                  </h4>
                  <!-- {{ series_status_analyzed }} -->
                  <div>
                    <div v-if="!loading_grafik && series_families[0]">
                      <apexchart
                        class="apex-charts"
                        dir="ltr"
                        height="370"
                        :series="[
                          this.series_status_analyzed.analyzed,
                          this.series_status_analyzed.not_analyzed,
                        ]"
                        :options="dataAnalyzedMalwares.chartOptions"
                      ></apexchart>
                    </div>
                    <div v-if="loading_grafik">
                      <div class="text-center py-4 my-5">
                        <i class="bx bx-loader-circle bx-spin bx-md"></i> <br />
                        <span class="font-size-16"> Loading ... </span>
                      </div>
                    </div>
                    <div v-if="!loading_grafik && !series_families[0]">
                      <div class="m-5 p-5">
                        <div class="text-center py-4 my-5">
                          <span class="py-5 my-5">
                            {{ $t("dashboards.data-not-found") }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-3">
          <div
            class="card-body border rounded-top"
            :class="theme == 'light' ? 'bg-white' : 'border-info'"
          >
            <label
              for="select"
              :class="theme == 'light' ? 'bg-white text-primary' : 'text-info'"
              >{{ $t("dashboards.statistics-interval") }}</label
            >
            <select
              class="form-control"
              id="class"
              v-model="sortInterval"
              @change="selectSandbox"
            >
              <option value="all">{{ $t("malware.all-time") }}</option>
              <option value="7d">{{ $t("malware.last-7") }}</option>
              <option value="30d">{{ $t("malware.last-30") }}</option>
              <option value="90d">{{ $t("malware.last-90") }}</option>
              <option value="dr">
                {{ $t("dashboards.date-range") }}
              </option>
            </select>
            <hr />
            <div v-if="sortInterval == 'dr'">
              <label
                for="select"
                :class="
                  theme == 'light' ? 'bg-white text-primary' : 'text-info'
                "
                >{{ $t("dashboards.start-interval") }}
              </label>
              <input
                class="form-control"
                type="date"
                id="class"
                v-model="start_range"
              />
              <br />
              <label
                for="select"
                :class="
                  theme == 'light' ? 'bg-white text-primary' : 'text-info'
                "
                >{{ $t("dashboards.end-interval") }}
              </label>
              <input
                class="form-control"
                type="date"
                id="class"
                v-model="end_range"
              />
              <b-button
                class="btn btn-sm btn-success mt-2 text-white"
                @click="selectSandbox()"
              >
                <span class="text-white"> {{ $t("dashboards.apply") }}</span>
              </b-button>

              <hr />
            </div>
            <label
              for="select"
              :class="theme == 'light' ? 'bg-white text-primary' : 'text-info'"
            >
              {{ $t("dashboards.select-sandbox") }}</label
            >
            <select
              class="form-control"
              id="sandbox"
              v-model="select_sandbox"
              @change="selectSandbox()"
            >
              <option value="all">{{ $t("malware.all") }}</option>
              <option value="ahn_lab">AhnLab</option>
              <option value="checkpoint">Checkpoint</option>
            </select>
          </div>
          <div
            class="card-body border"
            :class="theme == 'light' ? 'bg-white' : 'border-info'"
          >
            <table
              class="w-100 border-0"
              cellpadding="2"
              v-if="!loading_grafik"
            >
              <thead>
                <tr>
                  <td colspan="2">
                    <b>{{ $t("dashboards.malware-classification") }} </b>
                    <br />
                  </td>
                </tr>
              </thead>
              <tbody v-if="classification.length < 10">
                <tr v-for="(cls, clsid) in classification" :key="'CA' + clsid">
                  <td class="text-left" width="90">
                    <router-link :to="'/malware?search=' + cls.detect_name"
                      ><span class="text-muted rlink">{{
                        cls.detect_name
                      }}</span></router-link
                    >
                  </td>
                  <td class="text-right" width="10">{{ cls.total }}</td>
                </tr>
                <tr
                  v-for="(tr, index) in 10 - classification.length"
                  :key="index"
                >
                  <td class="text-left" width="90">-</td>
                  <td class="text-right" width="10">-</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr
                  v-for="(cls, clsid) in classification.slice(0, 10)"
                  :key="'CB' + clsid"
                >
                  <td class="text-left" width="90">
                    <router-link :to="'/malware?search=' + cls.detect_name"
                      ><span class="text-muted rlink">{{
                        cls.detect_name
                      }}</span></router-link
                    >
                  </td>
                  <td class="text-right" width="10">{{ cls.total }}</td>
                </tr>
              </tbody>
            </table>

            <div v-if="loading_grafik">
              <div class="text-center py-4 my-5">
                <i class="bx bx-loader-circle bx-spin bx-md"></i> <br />
                <span class="font-size-16"> Loading ... </span>
              </div>
            </div>
          </div>
          <div
            class="card-body border rounded-bottom"
            :class="theme == 'light' ? 'bg-white' : 'border-info'"
            v-if="sortInterval !== 'dr'"
          >
            <table
              class="w-100 border-0"
              cellpadding="2"
              v-if="!loading_grafik"
            >
              <thead>
                <tr>
                  <td colspan="2">
                    <b>{{ $t("dashboards.top-malicius-malware") }}</b>
                  </td>
                </tr>
              </thead>
              <tbody v-if="topDestination.length > 10">
                <tr
                  v-for="(dst, dsid) in topDestination.slice(0, 10)"
                  :key="'DA' + dsid"
                >
                  <td class="text-left" width="90">{{ dst.destination }}</td>
                  <td class="text-right" width="10">{{ dst.total }}</td>
                </tr>
              </tbody>

              <tbody v-else>
                <tr v-for="(dst, dsid) in topDestination" :key="'DB' + dsid">
                  <td class="text-left" width="90">{{ dst.destination }}</td>
                  <td class="text-right" width="10">{{ dst.total }}</td>
                </tr>
                <tr
                  v-for="(tr, index) in 10 - topDestination.length"
                  :key="'TPA' + index"
                >
                  <td class="text-left" width="90">-</td>
                  <td class="text-right" width="10">-</td>
                </tr>
              </tbody>
            </table>
            <div v-if="loading_grafik">
              <div class="text-center py-4 my-5">
                <i class="bx bx-loader-circle bx-spin bx-md"></i> <br />
                <span class="font-size-16"> Loading ... </span>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div
            class="card-body border rounded"
            :class="theme == 'light' ? 'bg-white' : 'border-info'"
          >
            <div v-if="loading_analyst">
              <div class="text-center py-4 my-5">
                <i class="bx bx-loader-circle bx-spin bx-md"></i> <br />
                <span class="font-size-16"> Loading ... </span>
              </div>
            </div>
            <div v-if="!loading_analyst && !top_reports[0]">
              <div class="m-5 p-5">
                <div class="text-center py-4 my-5">
                  <span class="py-5 my-5"> - </span>
                </div>
              </div>
            </div>
            <table
              class="w-100 border-0"
              cellpadding="2"
              v-if="!loading_analyst && top_reports[0]"
            >
              <thead>
                <tr>
                  <td colspan="2" class="pb-1">
                    <div class="row">
                      <div class="col-8">
                        <b>{{ $t("dashboards.top-analys") }} </b>
                      </div>
                      <div class="col-4">
                        <select
                          class="form-control form-control-sm"
                          id="sandbox"
                          v-model="select_status"
                          @change="getTopReports()"
                        >
                          <option value="4">All</option>
                          <option value="0">Draft</option>
                          <option value="1">Pending</option>
                          <option value="2">Not Valid</option>
                          <option value="3">Valid</option>
                        </select>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="border-bottom py-0">
                  <td
                    class="text-left"
                    width="40"
                    :class="
                      theme == 'light' ? 'bg-white text-primary' : 'text-info'
                    "
                  >
                    Analyst
                  </td>
                  <td
                    class="text-right"
                    width="60"
                    :class="
                      theme == 'light' ? 'bg-white text-primary' : 'text-info'
                    "
                  >
                    Total Report
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="border-bottom py-1"
                  v-for="tr in top_reports"
                  :key="tr.username"
                >
                  <td class="text-left" width="90">
                    <img
                      :src="urlImage + tr.avatar"
                      class="mr-3 rounded-circle avatar-xs border m-1"
                      alt="avatar"
                      v-if="tr.avatar"
                    />
                    <img
                      src="@/assets/images/users/avatar-10.jpg"
                      class="mr-3 rounded-circle avatar-xs border m-1"
                      alt="avatar"
                      v-else
                    />
                    <router-link
                      class="text-dark"
                      :to="{
                        path: '/malware/user/detail',
                        query: { id: base64Encode(tr.id) },
                      }"
                    >
                      {{ tr.username }}
                    </router-link>
                  </td>
                  <td class="text-right" width="10">{{ tr.total }}</td>
                </tr>

                <tr
                  class="border-bottom py-1"
                  v-for="(tr, index) in 5 - top_reports.length"
                  :key="'TRA' + index"
                >
                  <td class="text-left" width="90">
                    <img
                      src="@/assets/images/users/avatar-10.jpg"
                      class="mr-3 rounded-circle avatar-xs border m-1"
                      alt="avatar"
                    />
                    -
                  </td>
                  <td class="text-right" width="10">{{ tr.total }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- <Severity /> -->
    <div
      class="card-body border rounded mb-4"
      :class="theme == 'light' ? 'bg-white' : 'border-info'"
    >
      <div class="card-title mb-2 d-flex justify-content-between">
        <h5 class="">Malware Severity<br /><span class="text-info">-</span></h5>
      </div>
      <div>
        <div class="row">
          <div class="col-6">
            <div v-if="!loading_grafik && series_severity[0]">
              <apexchart
                class="apex-charts mt-3"
                dir="ltr"
                height="370"
                :series="series_severity"
                :options="{
                  stroke: {
                    colors: ['#e5e5e5'],
                  },
                  legend: {
                    show: true,
                    showForSingleSeries: false,
                    showForNullSeries: true,
                    showForZeroSeries: true,
                    position: 'bottom',
                    horizontalAlign: 'center',
                    floating: false,
                    fontSize: '14px',
                    fontFamily: 'Helvetica, Arial',
                    fontWeight: 400,
                    formatter: undefined,
                    inverseOrder: false,
                    width: undefined,
                    height: undefined,
                    tooltipHoverFormatter: undefined,
                    customLegendItems: [],
                    offsetX: 0,
                    offsetY: 0,
                    labels: {
                      colors: '#fff',
                      useSeriesColors: false,
                    },
                    markers: {
                      width: 12,
                      height: 12,
                      strokeWidth: 0,
                      strokeColor: '#fff',
                      fillColors: undefined,
                      radius: 12,
                      customHTML: undefined,
                      onClick: undefined,
                      offsetX: 0,
                      offsetY: 0,
                    },
                    itemMargin: {
                      horizontal: 5,
                      vertical: 4,
                    },
                    onItemClick: {
                      toggleDataSeries: true,
                    },
                    onItemHover: {
                      highlightDataSeries: true,
                    },
                  },
                  chart: {
                    type: 'pie',
                  },
                  labels: labels_severity,
                  colors: colors_severity,
                  plotOptions: {
                    pie: {
                      donut: {
                        size: '60%',
                      },
                    },
                  },
                }"
              >
              </apexchart>
            </div>
            <div v-if="loading_grafik">
              <div class="text-center py-4 my-5">
                <i class="bx bx-loader-circle bx-spin bx-md"></i> <br />
                <span class="font-size-16"> Loading ... </span>
              </div>
            </div>
          </div>
          <div class="col-6 pb-2">
            <div v-if="!loading_grafik && series_severity[0]">
              <apexchart
                class="apex-charts"
                dir="ltr"
                height="370"
                :series="[
                  {
                    name: 'Checkpoint',
                    data: [
                      series_severity_radar.normal,
                      series_severity_radar.low,
                      series_severity_radar.medium,
                      series_severity_radar.high,
                      series_severity_radar.severe,
                      series_severity_radar.emergency,
                    ],
                  },
                ]"
                :options="{
                  plotOptions: {
                    radar: {
                      polygons: {
                        strokeColor: '#e8e8e8',
                        fill: {
                          colors:
                            theme == 'dark'
                              ? ['#022B3A', '#17263C']
                              : ['#FFFFFF', '#F8F8FB'],
                        },
                      },
                    },
                  },
                  stroke: {
                    colors: ['#ffffff'],
                  },
                  colors: ['#FFF'],
                  dataLabels: {
                    style: {
                      colors: ['#FFF'],
                    },
                    enabled: true,
                    background: {
                      enabled: true,
                      borderRadius: 20,
                    },
                  },
                  fill: {
                    opacity: 0.7,
                  },
                  legend: {
                    show: false,
                    showForSingleSeries: false,
                    showForNullSeries: true,
                    showForZeroSeries: true,
                    position: 'right',
                    horizontalAlign: 'center',
                    floating: false,
                    fontSize: '14px',
                    fontFamily: 'Helvetica, Arial',
                    fontWeight: 400,
                    formatter: undefined,
                    inverseOrder: false,
                    width: undefined,
                    height: undefined,
                    tooltipHoverFormatter: undefined,
                    customLegendItems: [],
                    offsetX: 0,
                    offsetY: 0,
                    labels: {
                      colors: '#fff',
                      useSeriesColors: false,
                    },
                    markers: {
                      width: 12,
                      height: 12,
                      strokeWidth: 0,
                      strokeColor: '#fff',
                      fillColors: undefined,
                      radius: 12,
                      customHTML: undefined,
                      onClick: undefined,
                      offsetX: 0,
                      offsetY: 0,
                    },
                    itemMargin: {
                      horizontal: 5,
                      vertical: 4,
                    },
                    onItemClick: {
                      toggleDataSeries: true,
                    },
                    onItemHover: {
                      highlightDataSeries: true,
                    },
                  },
                  chart: {
                    height: 370,
                    type: 'radar',
                  },
                  labels: [
                    'Normal',
                    'Low',
                    'Medium',
                    'High',
                    'Severe',
                    'Emergency',
                  ],
                  colors: ['#92400D'],
                }"
              >
              </apexchart>
            </div>
            <div v-if="loading_grafik">
              <div class="text-center py-4 my-5">
                <i class="bx bx-loader-circle bx-spin bx-md"></i> <br />
                <span class="font-size-16"> Loading ... </span>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="!loading_grafik && !series_severity[0]">
            <div class="m-5 p-5">
              <div class="text-center py-4 my-5">
                <span class="py-5 my-5">
                  {{ $t("dashboards.data-not-found") }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Maps />

    <TopMalware />

    <div class="row mb-4">
      <div class="col-12">
        <DiskSpace :sandbox="select_sandbox" />
      </div>
    </div>

    <DailyReport />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
// import PageHeader from "@/components/page-header";
import Maps from "@/components/widgets/maps";
import TopMalware from "@/components/widgets/topmalware";
import DailyReport from "@/components/widgets/dailyreport";
import MalwareRecapitulation from "@/components/widgets/recapitulation";
import DiskSpace from "@/components/widgets/diskspace";
import Classification from "@/components/widgets/classification";
import StatisticsService from "@/helpers/statistics.service";
import { userService } from "@/helpers/authservice/user.service";
import ElasticService from "@/helpers/elastic.service";
import PreferencesServices from "@/helpers/preferences.service";
import { notificationMethods } from "@/state/helpers";
import moment from "moment";
import axios from "axios";
import _ from "lodash";

import {
  top10virus,
  malwareTypesDonutChart,
  reportStatistics,
  malwareRecapitulation,
} from "./data";

export default {
  page: {
    title: "LAB MALWARE",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Maps,
    Layout,
    TopMalware,
    DiskSpace,
    DailyReport,
    MalwareRecapitulation,
  },
  data() {
    const dataAnalyzedMalwares = {
      series: [0, 0],
      chartOptions: {
        stroke: {
          colors: ["#e5e5e5"],
        },
        legend: {
          show: true,
          showForSingleSeries: false,
          showForNullSeries: true,
          showForZeroSeries: true,
          position: "bottom",
          horizontalAlign: "center",
          floating: false,
          fontSize: "14px",
          fontFamily: "Helvetica, Arial",
          fontWeight: 400,
          formatter: undefined,
          inverseOrder: false,
          width: undefined,
          height: undefined,
          tooltipHoverFormatter: undefined,
          customLegendItems: [],
          offsetX: 0,
          offsetY: 0,
          labels: {
            colors: "#fff",
            useSeriesColors: false,
          },
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: "#fff",
            fillColors: undefined,
            radius: 12,
            customHTML: undefined,
            onClick: undefined,
            offsetX: 0,
            offsetY: 0,
          },
          itemMargin: {
            horizontal: 5,
            vertical: 4,
          },
          onItemClick: {
            toggleDataSeries: true,
          },
          onItemHover: {
            highlightDataSeries: true,
          },
        },
        chart: {
          type: "pie",
        },
        labels: ["Analyzed", "Not Yet Analyzed"],
        colors: ["#047857", "#E7515A"],

        plotOptions: {
          pie: {
            donut: {
              size: "60%",
            },
          },
        },
      },
    };

    return {
      start_range: "",
      end_range: "",
      loading_grafik: false,
      loading_analyst: false,
      refresh_token: 0,
      loginname: this.$store.state.authBackend.user.name,
      title: "LAB MALWARE",
      theme: localStorage.getItem("theme"),
      urlImage: process.env.VUE_APP_BASE_API_URL_AVATAR,
      series_status_analyzed: {
        analyzed: 0,
        not_analyzed: 0,
      },
      pref_cp: "",
      pref_ahn: "",
      pref_cp_auth: {
        username: "",
        password: "",
      },
      select_status: 3,
      data_cpoint_sn: [],
      rest_data: [],
      malwareSeverity: [],
      Severity: [],
      malwareClass: [],
      classification: [],
      series_status: [],
      series_families: [],
      labels_families: [],
      series_severity: [],
      series_severity_radar: {
        normal: 0,
        low: 0,
        medium: 0,
        high: 0,
        severe: 0,
        emergency: 0,
      },
      labels_severity: [],
      colors_severity: [],
      total_uploads: 0,
      destination: [],
      topDestination: [],
      top_reports: [],
      total_analys: 0,
      total_validator: 0,
      total_report: 0,
      total_admin: 0,
      malwareRecapitulation: malwareRecapitulation,
      top10virus,
      dataAnalyzedMalwares: dataAnalyzedMalwares,
      malwareTypesDonutChart: malwareTypesDonutChart,
      totalUser: [],
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
      ],
      sortInterval: "all",
      select_sandbox: "all",
    };
  },
  methods: {
    // ...notificationMethods,
    getPreferencesAhn() {
      this.loading_grafik = true;
      let ferr = 0;
      PreferencesServices.getByKey("elastic", "ahn_lab")
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getPreferencesAhn();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.totalUser = [];
            this.pref_ahn = response.data.data;
          }
          // this.selectSandbox();
          this.getPreferencesCP();
        })
        .catch((err) => {
          this.getPreferencesCP();
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getPreferencesAhn();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading = false;
          }
        });
    },

    getPreferencesCP() {
      let ferr = 0;
      PreferencesServices.getByKey("elastic", "checkpoint")
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getPreferencesCP();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.totalUser = [];
            this.pref_cp = response.data.data;
          }
          this.selectSandbox();
        })
        .catch((err) => {
          this.selectSandbox();
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getPreferencesCP();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading = false;
          }
        });
    },

    getTotal() {
      let ferr = 0;
      StatisticsService.getTotalUser()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getTotal();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.totalUser = [];
            response.data.data.forEach((val, index) => {
              const data = {
                no: index + 1,
                name: val.name,
                total: val.total,
              };
              if (val.name == "verf") {
                this.total_validator = val.total;
              } else if (val.name == "anly") {
                this.total_analys = val.total;
              } else if (val.name == "admn") {
                this.total_admin = val.total;
              }
              this.totalUser.push(data);
              // this.loading = false;
            });
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getTotal();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading = false;
          }
        });
    },

    getTotalUploads() {
      let ferr = 0;
      StatisticsService.getTotalUpload()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getTotalUploads();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.total_uploads = response.data.data[0].total;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getTotalUploads();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading = false;
          }
        });
    },

    getAnalyzedMalware() {
      let ferr = 0;
      const params = {
        int: this.sortInterval,
        start_date: this.formatDateAnalyzed(this.start_range),
        end_date: this.formatDateAnalyzed(this.end_range),
        sandbox: this.select_sandbox,
      };
      // console.log("params analyzed", params);
      StatisticsService.getMalwareAnalyzed(params)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getTotal();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            this.series_status_analyzed.analyzed = 0;
            this.series_status_analyzed.not_analyzed = 0;
            ferr = 2;
            // console.log("res", response.data.data);
            response.data.data.forEach((val, index) => {
              // const data = {
              //   no: index + 1,
              //   status: val.status,
              //   total: val.total,
              // };
              if (val.status == "1") {
                this.series_status_analyzed.analyzed = val.total;
              } else {
                this.series_status_analyzed.not_analyzed = val.total;
              }
              // this.totalUser.push(data);
              // this.loading = false;
            });
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getTotal();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading = false;
          }
        });
    },

    getTopReports() {
      this.loading_analyst = true;
      let ferr = 0;
      const data = {
        status: this.select_status,
      };
      StatisticsService.getTopReport(data)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getTopReports();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.top_reports = [];
            response.data.data.forEach((val, index) => {
              const data = {
                no: index + 1,
                id: val.id_user,
                username: val.username,
                avatar: val.avatar,
                total: val.total,
              };

              this.top_reports.push(data);
              this.loading_analyst = false;
            });
          }
        })
        .catch((err) => {
          this.loading_analyst = false;
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getTopReports();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading = false;
          }
        });
    },

    getTotalReports() {
      StatisticsService.getTotalReport()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getTotalReports();
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            this.total_report = response.data.data;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getTotalReports();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
        });
    },

    getAllSandbox() {
      if (this.select_sandbox == "all") {
        this.rest_data = [];
        this.getAhnClassification();
      }
    },

    allData() {
      this.loading_grafik = true;
      this.getCheckpointDestination();
      const all_data = this.rest_data;
      this.malwareClass = [];
      this.classification = [];
      this.series_status = [];
      this.series_families = [];
      this.labels_families = [];
      this.malwareSeverity = [];
      this.Severity = [];
      this.colors_severity = [];
      this.series_severity = [];
      this.labels_severity = [];
      this.series_severity_radar = {
        normal: 0,
        low: 0,
        medium: 0,
        high: 0,
        severe: 0,
        emergency: 0,
      };

      const grouped = _.groupBy(all_data, (rep) => rep._source.detect_name);
      _.map(_.values(grouped), (arr) => {
        const val = arr[0];
        if (val._source.detect_name) {
          var detect_name_all = val._source.detect_name;
        } else {
          var detect_name_all = "Unknown";
        }
        const data = {
          id: val._source.id,
          detect_time: val._source.detect_time,
          detect_name: detect_name_all,
          total: arr.length,
        };
        this.malwareClass.push(data);
      });

      const groupedseverity = _.groupBy(
        all_data,
        (rep) => rep._source.severity
      );
      _.map(_.values(groupedseverity), (arr) => {
        const val = arr[0];
        // console.log('ahn arr', val);
        const data = {
          id: val._source.id,
          severity: val._source.severity,
          total: arr.length,
        };
        this.malwareSeverity.push(data);
      });

      // status analyzed
      // this.series_status_analyzed.analyzed = 0;
      // this.series_status_analyzed.not_analyzed = 0;
      // all_data.forEach((val) => {
      //   // console.log('source', val._source.status);
      //   if (val._source.status.code) {
      //     if (val._source.status.code == 1001) {
      //       this.series_status_analyzed.analyzed =
      //         this.series_status_analyzed.analyzed + 1;
      //     } else {
      //       this.series_status_analyzed.not_analyzed =
      //         this.series_status_analyzed.not_analyzed + 1;
      //     }
      //   } else {
      //     if (val._source.status == "done") {
      //       this.series_status_analyzed.analyzed =
      //         this.series_status_analyzed.analyzed + 1;
      //     } else {
      //       this.series_status_analyzed.not_analyzed =
      //         this.series_status_analyzed.not_analyzed + 1;
      //     }
      //   }
      // });

      let sort = _.orderBy(this.malwareClass, ["total"], ["desc"]);
      this.classification = sort;
      sort.forEach((val, index) => {
        this.labels_families.push(val.detect_name);
        this.series_families.push(val.total);
      });

      let sortSaverity = _.orderBy(this.malwareSeverity, ["total"], ["desc"]);
      this.Severity = sortSaverity;
      sortSaverity.forEach((val, index) => {
        const low = "#FEB019";
        const medium = "#008FFB";
        const normal = "#047857";
        const high = "#E7515A";
        // console.log('saverty', val.severity);

        if (val.severity === "low") {
          this.colors_severity.push(low);
          this.series_severity_radar.low =
            this.series_severity_radar.low + val.total;
        } else if (val.severity === "medium") {
          this.colors_severity.push(medium);
          this.series_severity_radar.medium =
            this.series_severity_radar.medium + val.total;
        } else if (val.severity === "likely normal") {
          this.colors_severity.push(normal);
          this.series_severity_radar.normal =
            this.series_severity_radar.normal + val.total;
        } else if (val.severity === "high") {
          this.colors_severity.push(high);
          this.series_severity_radar.high =
            this.series_severity_radar.high + val.total;
        } else if (val.severity === "severe") {
          this.colors_severity.push(severe);
          this.series_severity_radar.severe =
            this.series_severity_radar.severe + val.total;
        } else if (val.severity === "emergency") {
          this.colors_severity.push(emergency);
          this.series_severity_radar.emergency =
            this.series_severity_radar.emergency + val.total;
        }

        this.labels_severity.push(val.severity);
        this.series_severity.push(val.total);
      });

      this.loading_grafik = false;
    },

    getAhnClassification() {
      this.loading_grafik = true;
      let ferr = 0;
      if (this.sortInterval == "7d") {
        var date = new Date(new Date().setDate(new Date().getDate() - 7));
      } else if (this.sortInterval == "30d") {
        var date = new Date(new Date().setDate(new Date().getDate() - 30));
      } else if (this.sortInterval == "90d") {
        var date = new Date(new Date().setDate(new Date().getDate() - 90));
      }
      const tgl = this.formatDate(date);
      const nowx = new Date();
      const now = this.formatDate(nowx);

      //  range: {
      //             tanggal_lahir: {
      //               gte: this.formatDate(this.form.tanggal_lahir),
      //               lte: this.formatDate(this.form.tanggal_lahir),
      //               time_zone: "Asia/Jakarta",
      //             },
      //           },

      if (this.sortInterval == "all") {
        var dataquery = {
          query: {
            bool: {
              must: [],
              filter: [
                {
                  bool: {
                    should: [
                      {
                        range: {
                          "detect_time.keyword": {
                            lt: now,
                          },
                        },
                      },
                    ],
                    minimum_should_match: 1,
                  },
                },
              ],
              should: [],
              must_not: [],
            },
          },
        };
      } else if (this.sortInterval == "dr") {
        var dataquery = {
          query: {
            bool: {
              must: [],
              filter: [
                {
                  bool: {
                    should: [
                      {
                        range: {
                          "detect_time.keyword": {
                            gte: this.formatDate(this.start_range),
                            lte: this.formatDate(this.end_range),
                            time_zone: "Asia/Jakarta",
                          },
                        },
                      },
                    ],
                    minimum_should_match: 1,
                  },
                },
              ],
              should: [],
              must_not: [],
            },
          },
        };
      } else {
        var dataquery = {
          query: {
            bool: {
              must: [],
              filter: [
                {
                  bool: {
                    should: [
                      {
                        range: {
                          "detect_time.keyword": {
                            gt: tgl,
                          },
                        },
                      },
                    ],
                    minimum_should_match: 1,
                  },
                },
              ],
              should: [],
              must_not: [],
            },
          },
        };
      }

      if (this.pref_ahn.username && this.pref_ahn.password) {
        // console.log('mulai encode');
        let us = this.pref_ahn.username;
        let ps = this.pref_ahn.password;
        let base = this.encode(us, ps);
        var basedata_ahn = "Basic " + base + "";
      } else {
        var basedata_ahn = null;
      }
      // console.log('ahn api host', this.pref_ahn.api_host);
      ElasticService.getAhnLab(this.pref_ahn.api_host, dataquery, basedata_ahn)
        .then((response) => {
          const data_ahn = response.data.hits.hits;
          if (this.select_sandbox == "all") {
            data_ahn.forEach((val) => {
              const data = {
                _id: val._id,
                _index: val._index,
                _score: val._score,
                _source: val._source,
                _type: val._source,
              };
              this.rest_data.push(data);
            });
            this.getCheckpointClassification();
          }

          if (this.select_sandbox == "ahn_lab") {
            this.Severity = [];
            this.colors_severity = [];
            this.series_severity = [];
            this.labels_severity = [];
            this.series_severity_radar = {
              normal: 0,
              low: 0,
              medium: 0,
              high: 0,
              severe: 0,
              emergency: 0,
            };
            this.malwareClass = [];
            this.classification = [];
            this.series_status = [];
            this.series_families = [];
            this.labels_families = [];
            this.malwareSeverity = [];

            const grouped = _.groupBy(
              data_ahn,
              (rep) => rep._source.detect_name
            );
            _.map(_.values(grouped), (arr) => {
              const val = arr[0];

              if (val._source.detect_name) {
                var detect_name_ahn = val._source.detect_name;
              } else {
                var detect_name_ahn = "Unknown";
              }
              // console.log('ahn arr', val);
              const data = {
                id: val._source.id,
                detect_time: val._source.detect_time,
                detect_name: detect_name_ahn,
                total: arr.length,
              };
              this.malwareClass.push(data);
            });

            const groupedseverity = _.groupBy(
              data_ahn,
              (rep) => rep._source.severity
            );
            _.map(_.values(groupedseverity), (arr) => {
              const val = arr[0];
              // console.log('ahn arr', val);
              const data = {
                id: val._source.id,
                severity: val._source.severity,
                total: arr.length,
              };
              this.malwareSeverity.push(data);
            });

            // this.series_status_analyzed.analyzed = 0;
            // this.series_status_analyzed.not_analyzed = 0;
            // data_ahn.forEach((val) => {
            //   // console.log(val._source.status);
            //   if (val._source.status == "done") {
            //     this.series_status_analyzed.analyzed =
            //       this.series_status_analyzed.analyzed + 1;
            //   } else {
            //     this.series_status_analyzed.not_analyzed =
            //       this.series_status_analyzed.not_analyzed + 1;
            //   }
            // });

            let sort = _.orderBy(this.malwareClass, ["total"], ["desc"]);
            this.classification = sort;
            sort.forEach((val, index) => {
              this.labels_families.push(val.detect_name);
              this.series_families.push(val.total);
            });

            let sortSaverity = _.orderBy(
              this.malwareSeverity,
              ["total"],
              ["desc"]
            );
            this.Severity = sortSaverity;
            sortSaverity.forEach((val) => {
              const low = "#FEB019";
              const medium = "#008FFB";
              const normal = "#047857";
              const high = "#E7515A";
              // console.log('saver', val.severity);

              if (val.severity === "low") {
                this.colors_severity.push(low);
                this.series_severity_radar.low =
                  this.series_severity_radar.low + val.total;
              } else if (val.severity === "medium") {
                this.colors_severity.push(medium);
                this.series_severity_radar.medium =
                  this.series_severity_radar.medium + val.total;
              } else if (val.severity === "likely normal") {
                this.colors_severity.push(normal);
                this.series_severity_radar.normal =
                  this.series_severity_radar.normal + val.total;
              } else if (val.severity === "high") {
                this.colors_severity.push(high);
                this.series_severity_radar.high =
                  this.series_severity_radar.high + val.total;
              } else if (val.severity === "severe") {
                this.colors_severity.push(severe);
                this.series_severity_radar.severe =
                  this.series_severity_radar.severe + val.total;
              } else if (val.severity === "emergency") {
                this.colors_severity.push(emergency);
                this.series_severity_radar.emergency =
                  this.series_severity_radar.emergency + val.total;
              }

              this.labels_severity.push(val.severity);
              this.series_severity.push(val.total);
            });
            this.loading_grafik = false;
          }
        })
        .catch((err) => {
          if (this.select_sandbox == "ahn_lab") {
            this.Severity = [];
            this.colors_severity = [];
            this.series_severity = [];
            this.labels_severity = [];
            this.series_severity_radar = {
              normal: 0,
              low: 0,
              medium: 0,
              high: 0,
              severe: 0,
              emergency: 0,
            };
            this.malwareClass = [];
            this.classification = [];
            this.series_status = [];
            this.series_families = [];
            this.labels_families = [];
            this.malwareSeverity = [];
          }
          this.loading = false;
          this.getCheckpointClassification();
          this.loading_grafik = false;
        });
    },

    getCheckpointClassification() {
      this.loading_grafik = true;
      let ferr = 0;
      if (this.sortInterval == "7d") {
        var date = new Date(new Date().setDate(new Date().getDate() - 7));
      } else if (this.sortInterval == "30d") {
        var date = new Date(new Date().setDate(new Date().getDate() - 30));
      } else if (this.sortInterval == "90d") {
        var date = new Date(new Date().setDate(new Date().getDate() - 90));
      }
      const tgl = this.formatDate(date);
      const nowx = new Date();
      const now = this.formatDate(nowx);
      if (this.sortInterval == "all") {
        var dataquery2 = {
          query: {
            bool: {
              must: [],
              filter: [
                {
                  bool: {
                    should: [
                      {
                        range: {
                          detect_time: {
                            lt: now,
                          },
                        },
                      },
                    ],
                    minimum_should_match: 1,
                  },
                },
              ],
              should: [],
              must_not: [],
            },
          },
        };
      } else if (this.sortInterval == "dr") {
        var dataquery2 = {
          query: {
            bool: {
              must: [],
              filter: [
                {
                  bool: {
                    should: [
                      {
                        range: {
                          "detect_time.keyword": {
                            gte: this.formatDate(this.start_range),
                            lte: this.formatDate(this.end_range),
                            time_zone: "Asia/Jakarta",
                          },
                        },
                      },
                    ],
                    minimum_should_match: 1,
                  },
                },
              ],
              should: [],
              must_not: [],
            },
          },
        };
      } else {
        var dataquery2 = {
          query: {
            bool: {
              must: [],
              filter: [
                {
                  bool: {
                    should: [
                      {
                        range: {
                          detect_time: {
                            gt: tgl,
                          },
                        },
                      },
                    ],
                    minimum_should_match: 1,
                  },
                },
              ],
              should: [],
              must_not: [],
            },
          },
        };
      }

      // ElasticService.getCheckpointLab(data);
      if (this.pref_cp.username && this.pref_ahn.password) {
        let us = this.pref_cp.username;
        let ps = this.pref_cp.password;
        let base = this.encode(us, ps);
        var basedata_cp = "Basic " + base + "";
      } else {
        var basedata_cp = null;
      }

      ElasticService.getCheckpointLab(
        this.pref_cp.api_host,
        dataquery2,
        basedata_cp
      )
        .then((response) => {
          this.data_cpoint_sn = [];
          const data_cpoint = response.data.hits.hits;
          data_cpoint.forEach((val) => {
            if (val._source.av.malware_info) {
              this.data_cpoint_sn.push(val);
            }
          });
          if (this.select_sandbox == "all") {
            this.data_cpoint_sn.forEach((val) => {
              if (val._source.av.malware_info) {
                var signa = val._source.av.malware_info.signature_name;
              } else {
                var signa = "Unknown";
              }

              if (
                val._source.te.severity == 1 ||
                val._source.te.severity == 2
              ) {
                var all_severity = "low";
              } else if (
                val._source.te.severity == 3 ||
                val._source.te.severity == 4
              ) {
                var all_severity = "medium";
              } else if (
                val._source.te.severity == 5 ||
                val._source.te.severity == 6
              ) {
                var all_severity = "high";
              } else if (
                val._source.te.severity == 7 ||
                val._source.te.severity == 8
              ) {
                var all_severity = "severe";
              } else if (
                val._source.te.severity == 9 ||
                val._source.te.severity == 10
              ) {
                var all_severity = "emergency";
              } else if (val._source.te.severity == 0) {
                var all_severity = "likely normal";
              }
              const source = {
                id: val._source.id,
                detect_name: signa,
                severity: all_severity,
                detect_time: val._source.detect_time,
                status: val._source.status,
              };
              const data = {
                _id: val._id,
                _index: val._index,
                _score: val._score,
                _source: source,
                _type: val._source,
              };

              this.rest_data.push(data);
            });
            this.allData();
          }

          if (this.select_sandbox == "checkpoint") {
            this.malwareClass = [];
            this.classification = [];
            this.series_status = [];
            this.series_families = [];
            this.labels_families = [];
            this.malwareSeverity = [];
            this.Severity = [];
            this.colors_severity = [];
            this.series_severity = [];
            this.labels_severity = [];
            this.series_severity_radar = {
              normal: 0,
              low: 0,
              medium: 0,
              high: 0,
              severe: 0,
              emergency: 0,
            };

            const grouped = _.groupBy(
              this.data_cpoint_sn,
              (rep) => rep._source.av.malware_info.signature_name
            );
            _.map(_.values(grouped), (arr) => {
              const val = arr[0];
              if (val._source) {
                if (val._source.av.malware_info.signature_name) {
                  var detect_name_cp =
                    val._source.av.malware_info.signature_name;
                } else {
                  var detect_name_cp = "Unknown";
                }
                const data = {
                  id: val._source.id,
                  detect_time: val._source.detect_time,
                  detect_name: detect_name_cp,
                  total: arr.length,
                };
                this.malwareClass.push(data);
              } else {
                // console.log('cp arr tidak ada');
              }
            });

            const groupedseverity = _.groupBy(
              this.data_cpoint_sn,
              (rep) => rep._source.te.severity
            );
            _.map(_.values(groupedseverity), (arr) => {
              const val = arr[0];
              // console.log('cp arr', val);
              if (
                val._source.te.severity == 1 ||
                val._source.te.severity == 2 ||
                val._source.te.severity == 3
              ) {
                var s_severity = "low";
              } else if (
                val._source.te.severity == 4 ||
                val._source.te.severity == 5 ||
                val._source.te.severity == 6 ||
                val._source.te.severity == 7
              ) {
                var s_severity = "medium";
              } else if (
                val._source.te.severity == 8 ||
                val._source.te.severity == 9 ||
                val._source.te.severity == 10
              ) {
                var s_severity = "high";
              } else if (val._source.te.severity == 0) {
                var s_severity = "likely normal";
              }

              //  if(val._source.av){
              //    console.log('severity', val._source);
              //  }

              var data = {
                id: val._source.sha1,
                severity: s_severity,
                total: arr.length,
              };
              this.malwareSeverity.push(data);
            });

            // // status analyzed
            // this.series_status_analyzed.analyzed = 0;
            // this.series_status_analyzed.not_analyzed = 0;
            // this.data_cpoint_sn.forEach((val) => {
            //   // console.log(val._source.av.status.code);
            //   if (val._source.av.status.code == 1001) {
            //     this.series_status_analyzed.analyzed =
            //       this.series_status_analyzed.analyzed + 1;
            //   } else {
            //     this.series_status_analyzed.not_analyzed =
            //       this.series_status_analyzed.not_analyzed + 1;
            //   }
            // });

            let sort = _.orderBy(this.malwareClass, ["total"], ["desc"]);
            this.classification = sort;
            sort.forEach((val, index) => {
              // console.log('family', val);
              this.labels_families.push(val.detect_name);
              this.series_families.push(val.total);
            });

            let sortSaverity = _.orderBy(
              this.malwareSeverity,
              ["total"],
              ["desc"]
            );
            this.Severity = sortSaverity;
            sortSaverity.forEach((val) => {
              const low = "#FEB019";
              const medium = "#008FFB";
              const normal = "#047857";
              const high = "#E7515A";
              // console.log('saver', val.severity);

              if (val.severity === "low") {
                this.colors_severity.push(low);
                this.series_severity_radar.low =
                  this.series_severity_radar.low + val.total;
              } else if (val.severity === "medium") {
                this.colors_severity.push(medium);
                this.series_severity_radar.medium =
                  this.series_severity_radar.medium + val.total;
              } else if (val.severity === "likely normal") {
                this.colors_severity.push(normal);
                this.series_severity_radar.normal =
                  this.series_severity_radar.normal + val.total;
              } else if (val.severity === "high") {
                this.colors_severity.push(high);
                this.series_severity_radar.high =
                  this.series_severity_radar.high + val.total;
              } else if (val.severity === "severe") {
                this.colors_severity.push(severe);
                this.series_severity_radar.severe =
                  this.series_severity_radar.severe + val.total;
              } else if (val.severity === "emergency") {
                this.colors_severity.push(emergency);
                this.series_severity_radar.emergency =
                  this.series_severity_radar.emergency + val.total;
              }

              this.labels_severity.push(val.severity);
              this.series_severity.push(val.total);
            });

            this.loading_grafik = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.loading_grafik = false;
          if (this.select_sandbox == "all") {
            this.allData();
          }
        });
    },

    getCheckpointDestination() {
      let ferr = 0;
      if (this.sortInterval == "7d") {
        var date = new Date(new Date().setDate(new Date().getDate() - 7));
      } else if (this.sortInterval == "30d") {
        var date = new Date(new Date().setDate(new Date().getDate() - 30));
      } else if (this.sortInterval == "90d") {
        var date = new Date(new Date().setDate(new Date().getDate() - 90));
      }

      const tgl = this.formatDate(date);
      const nowx = new Date();
      const now = this.formatDate(nowx);
      if (this.sortInterval == "all") {
        var dataquery3 = {
          query: {
            bool: {
              must: [],
              filter: [
                {
                  bool: {
                    should: [
                      {
                        range: {
                          time: {
                            lt: now,
                            time_zone: "Asia/Jakarta",
                          },
                        },
                      },
                    ],
                    minimum_should_match: 1,
                  },
                },
              ],
              should: [],
              must_not: [],
            },
          },
        };
      } else {
        var dataquery3 = {
          query: {
            bool: {
              must: [],
              filter: [
                {
                  bool: {
                    should: [
                      {
                        range: {
                          time: {
                            gt: tgl,
                            time_zone: "Asia/Jakarta",
                          },
                        },
                      },
                    ],
                    minimum_should_match: 1,
                  },
                },
              ],
              should: [],
              must_not: [],
            },
          },
        };
      }
      if (this.pref_cp.username) {
        let us = this.pref_cp.username;
        let ps = this.pref_cp.password;
        let base = this.encode(us, ps);
        var basedata_cp = "Basic " + base + "";
      } else {
        var basedata_cp = null;
      }
      // ElasticService.getCheckpointLab(data)
      ElasticService.getCheckpointLab(
        this.pref_cp.api_host,
        dataquery3,
        basedata_cp
      )
        .then((response) => {
          this.destination = [];
          this.topDestination = [];
          let data_cp = response.data.hits.hits;
          const grouped = _.groupBy(data_cp, (rep) => rep._source.dst);
          _.map(_.values(grouped), (arr) => {
            const val = arr[0];
            const data = {
              id: val._source.id,
              time: val._source.time,
              destination: val._source.dst,
              total: arr.length,
            };
            this.destination.push(data);
          });
          // status
          let sort = _.orderBy(this.destination, ["total"], ["desc"]);
          this.topDestination = sort;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    selectSandbox() {
      this.getAnalyzedMalware();
      if (this.select_sandbox == "ahn_lab") {
        this.Severity = [];
        this.colors_severity = [];
        this.series_severity = [];
        this.labels_severity = [];
        this.series_severity_radar = {
          normal: 0,
          low: 0,
          medium: 0,
          high: 0,
          severe: 0,
          emergency: 0,
        };
        this.classification = [];
        this.series_status = [];
        this.series_families = [];
        this.labels_families = [];
        this.getAhnClassification();
        this.topDestination = [];
      } else if (this.select_sandbox == "checkpoint") {
        this.Severity = [];
        this.colors_severity = [];
        this.series_severity = [];
        this.labels_severity = [];
        this.series_severity_radar = {
          normal: 0,
          low: 0,
          medium: 0,
          high: 0,
          severe: 0,
          emergency: 0,
        };
        this.classification = [];
        this.series_status = [];
        this.series_families = [];
        this.labels_families = [];
        this.getCheckpointClassification();
        this.getCheckpointDestination();
      } else if (this.select_sandbox == "all") {
        this.getAllSandbox();
      }
    },

    base64Encode(id) {
      return Buffer.from(id).toString("base64");
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },

    formatDateAnalyzed(value) {
      return moment(value).format("YYYYMMDD");
    },

    encode(us, ps) {
      let usps = us + ":" + ps;
      return Buffer.from(usps).toString("base64");
      // console.log('hsl', usps, hsl);
    },
  },
  beforeMount() {
    this.getPreferencesAhn();
  },
  mounted() {
    this.getTotal();
    this.getAnalyzedMalware();
    this.getTotalReports();
    this.getTopReports();
    this.getTotalUploads();
    // this.getCheckpointClassification();
    // this.getCheckpointDestination();
  },
};
</script>

<style scoped>
.rlink:hover {
  text-decoration: underline;
}
</style>
